<template>
	<div>
		<div class="border">
			<titlecom class="padding" :title="text.title" :content="text.content" :type="text.type"></titlecom>
			<!-- 倒计时 -->
			<div>
				<div style="margin-left: 20px;margin-bottom: 15px;color: #666;">距会议开始还剩：</div>
				<div class="flex" style="justify-content: space-around;margin: 0 auto;width: 80%;margin-bottom: 20px;">
					<div class="time_box" style="background-color: #e23549;">{{d}}天</div>
					<div class="time_box">{{h}}时</div>
					<div class="time_box">{{m}}分</div>
					<div class="time_box">{{s}}秒</div>
				</div>


			</div>


			<div class="line"></div>
			<titlecom class="padding" :title="meetingIn.title" :content="meetingIn.content" :type="meetingIn.type"></titlecom>
			<div class="line"></div>


			<!-- <div class="box" v-for="(item,index) in leftMenu">
				<span class="iconfont icon-icon-shexiangji"></span>
				{{item.title}}
			</div> -->


			<!-- 组织机构 -->
			<div>
				<titlecom class="padding" :title="organization.title" :content="organization.content" :type="meetingIn.type"></titlecom>
				<div style="margin-bottom:15px">
					<p class="title-host">主办单位：</p>
					<div class="margin"> 中华医学会</div>
					<div class="margin"> 中华医学会细菌感染与耐药防治分会</div>
				</div>
				<div style="margin-bottom:15px">
					<p class="title-host">协办单位：</p>
					<div class="margin"> 复旦大学附属华山医院抗生素研究所</div>
				</div>
				<!-- <div>
					<p class="title-host">协办单位：</p>
					<div class="margin"> 深圳市医学会 </div>
					<div class="margin"> 深圳市医师协会 </div>
					<div class="margin"> 深圳市人民医院 </div>
				</div> -->
			</div>

			<div class="line"></div>
			<!-- 组织机构 -->
			<div>
				<titlecom class="padding" :title="contactUs"></titlecom>
				<div class="we-title lianxi">注册咨询</div>
				<div v-for="(item,index) in contactUsList">
					<span class="we-title">{{item.title}}</span> <span style="font-size: 14px;">{{item.content}}</span>
				</div>
				<div class="we-title lianxi" style="margin-top: 10px;">住宿订房</div>
				<div v-for="(item,index) in contactUsListTwo">
					<div>
						<span class="we-title">{{item.title}}</span>
					</div>
					<div style="width: 250px;margin-left: 80px;margin-top: -25px">
						<span style="font-size: 14px;">{{item.content}}</span>
					</div>

				</div>
				<div class="we-title lianxi" style="margin-top: 10px;">企业参会</div>
				<div v-for="(item,index) in contactUsListThree">
					<span class="we-title">{{item.title}}</span> <span style="font-size: 14px;">{{item.content}}</span>
				</div>

				<div class="we-title lianxi" style="margin-top: 10px;">线上支持</div>
				<div v-for="(item,index) in contactUsListFour">
					<span class="we-title">{{item.title}}</span> <span style="font-size: 14px;">{{item.content}}</span>
				</div>
			</div>


		</div>
	</div>
</template>

<script>
	import titlecom from "@/components/title/title.vue";
	export default {
		data() {
			return {
				d: '',
				h: '',
				m: '',
				s: '',
				sum_h: '',
				contactUs: '联系我们',
				organization: {
					title: '组织机构',
					content: [

					],
					type: 'sort'
				},
				contactUsList: [{
						title: '联系人:',
						content: '瞿韦平'
					},
					{
						title: '电话:',
						content: '180-1600-8787'
					},
					{
						title: '邮箱:',
						content: 'quwp@fumed.com.cn'
					},
				],

				contactUsListTwo: [{
						title: '联系人:',
						content: '彭悦'
					},
					{
						title: '电话:',
						content: '173 1728 2021，021-64453107（转BISC感染会项目组）'
					},
					{
						title: '邮箱:',
						content: 'pengyue@fumed. com.cn'
					},
				],
				contactUsListThree: [{
						title: '联系人:',
						content: '朱永赞'
					},
					{
						title: '电话:',
						content: '010-51322757'
					},
					{
						title: '邮箱:',
						content: 'zhuyz@cma.org.cn'
					},
				],
				contactUsListFour: [{
					title: '联系人:',
					content: '贺淼',
				}, {
					title: '电话:',
					content: '183-1038-0289',
				}, {
					title: '邮箱:',
					content: 'ganzhiyuhm@163.com',
				}],


				meetingIn: {
					title: '重要时间',
					content: [
						'会议时间：4月8-10日（周四-周六）',
						'8日会议报到',
						'9日全天学术会议',
						'10日全天学术会议',
						// '29日撤离',
					],
					type: 'list'
				},
				time: {
					title: '重要时间',
					content: [],
					type: 'list'
				},
				text: {
					title: '倒计时',
					content: '',
					type: 'text'
				},

				// leftMenu:[
				//   {
				//     title:'大会直播',
				//     id:1
				//   },
				//   {
				//     title:'大会直播',
				//     id:2
				//   },
				//   {
				//     title:'大会直播',
				//     id:3
				//   },
				//   {
				//     title:'大会直播',
				//     id:4
				//   },
				//   {
				//     title:'大会直播',
				//     id:5
				//   },
				// ]


			}
		},

		methods: {
			countTime: function() {
				// 定义结束时间戳
				const end = Date.parse(new Date('2021-4-8 00:00:00'))
				// 定义当前时间戳
				const now = Date.parse(new Date())
				// 做判断当倒计时结束时都为0
				if (now >= end) {
					this.d = 0
					this.h = 0
					this.m = 0
					this.s = 0
					return
				}
				// 用结束时间减去当前时间获得倒计时时间戳
				const msec = end - now
				let d = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
				let h = parseInt(msec / 1000 / 60 / 60 % 24) //算出小时数
				let m = parseInt(msec / 1000 / 60 % 60) //算出分钟数
				let s = parseInt(msec / 1000 % 60) //算出秒数
				//给数据赋值
				this.d = d
				this.h = h > 9 ? h : '0' + h
				this.m = m > 9 ? m : '0' + m
				this.s = s > 9 ? s : '0' + s
				//定义this指向
				const that = this
				// 使用定时器 然后使用递归 让每一次函数能调用自己达到倒计时效果
				setTimeout(function() {
					that.countTime()
				}, 1000)
			}
		},

		components: {
			titlecom
		},
		mounted() {
			this.countTime()
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/style.scss';

	.border {
		border: 1px solid rgba(0, 0, 0, 0.2);
		width: 100%;
		padding-bottom: 20px;

	}

	.padding {
		margin: 10px 10px;
		font-size: 16px
	}

	.line {
		width: 100%;
		height: 1px;
		border-top: 1px solid rgba(0, 0, 0, 0.2);
	}

	.box {
		width: 85%;
		height: 50px;
		border: 1px solid #428dc4;
		line-height: 50px;
		margin: 20px auto;
		color: #428dc4;
		padding-left: 20px;
	}

	.box:hover {
		background-color: #428dc4;
		color: #fff;
	}

	.title-host {
		color: #505050;
		font-size: 16px;
		margin: 10px;
		margin: 0;
		margin-bottom: 5px;
		margin-left: 15px;
		font-family: "Microsoft YaHei";
		font-weight: bold;


	}

	.margin {
		margin-left: 30px;
		line-height: 30px;
		color: #616161;
	}

	.we-title {
		font-size: 14px;
		color: #000000;
		font-weight: bold;
		margin-left: 30px;
		line-height: 25px;
	}

	.lianxi {
		color: rgb(20, 90, 245);
		font-size: 15px;
		margin-bottom: 0px;
	}

	.time_box {
		width: 50px;
		height: 40px;
		background-color: #555;
		line-height: 40px;
		text-align: center;
		color: #fff;
		font-size: 14px;
	}
</style>
